import event from '@/event-bus/event';

export default {
  name: 'gt-alert',
  mixins: [],
  extends: {},
  components: {  },
  props: [],
  data() {
    return {
      isShow: false,
      // 0為空 1為message alert 2.為權限選擇器
      alertType: 0,
      alertMsg: '',
      verify: {
        acct: null,
        phoneArray: [],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$bus.$on(event.authVerifyAlert, (param) => {
       this.isShow = true;
    });
  },
  mounted() {
    $("[data-fancybox]").fancybox({
      smallBtn: true,
      toolbar: false
    });
    $("[data-fancybox].iframeS").fancybox({
      smallBtn: true,
      toolbar: false,
      afterLoad: function(event, ui) {
        $('.fancybox-content').addClass('small')
      }
    });
  },
  updated() {},
  beforeDestroy() {
  },
  methods: {
    closeBox() {
      this.init();
      this.isShow = false;
    },
    init() {
      this.alertType = 0;
      this.alertMsg = '';
      this.verify = {
        acct: null,
        phoneArray: [],
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/billing/alert/gt-alert.js